import React, { Component,Fragment } from 'react';
import { Table, Button, Icon, Divider, Modal, message, Spin , Input, Tooltip} from 'antd';
import { connect } from 'react-redux';
//import { CopyToClipboard } from 'react-copy-to-clipboard';

import { getCategories, deleteCategory } from '../../../../../../actions';
import { rolesToString } from '../../../../../../utils/roles';

import { prepSearch } from '../../../../../../utils/params';

class CategoriesTable extends Component {
  state = {
    searchText: '',
  }
  
  componentWillMount() {
    this.props.getCategories();
  }

  columns = [{
    title: 'Tên danh mục',
    dataIndex: 'name',
    render: (text, record) => (
      <Tooltip placement="topLeft" title={`/danh-muc/${record.slug}-${record.key}`} >
        <a href={`/danh-muc/${record.slug}-${record.key}`} target='_blank'>{text}</a>
      </Tooltip>  
    ),
    width: 300,
  },
  {
    title: 'Người tạo',
    key: 'user',
    render: (_, record) => <span>{record.user && record.user.lecturerId}</span>,
    width: 120,
  },   
  {
    title: 'Quyền liên quan',
    dataIndex: 'roles',
  }, {
    title: 'Tùy chỉnh',
    key: 'action',
    render: (text, record) => (
      <span>
      {/*
        <CopyToClipboard text={`/danh-muc/${record.slug}-${record.key}`} onCopy={() => message.success('Copied')}>
          <a role='button'><Icon type="copy" />{' '}Copy URL</a>
        </CopyToClipboard>
        <Divider type="vertical" />
       */}
        <Fragment>
        <a role='button' onClick={() => { this.handleEdit(record.key); }}><Icon type="edit" />{' '}Sửa</a>
        <Divider type="vertical" />
        <a role='button' onClick={() => { this.handleDelete(record.key); }}><Icon type="delete" />{' '}Xóa</a>
        </Fragment>
      </span>
    ),
    width: 140,
  }];

  createCategory = () => {
    this.props.showCategoryEditor();
  }

  handleEdit = (key) => {
    const category = this.props.category.categories.find(item => item._id === key);
    this.props.showCategoryEditor(category);
  }

  handleDelete = (key) => {
    const category = this.props.category.categories.find(item => item._id === key);
    Modal.confirm({
      title: `Bạn chắc chắn xóa danh mục "${category.name}"`,
      onText: 'Xóa',
      okType: 'danger',
      cancleText: 'Hủy',
      onOk: () => {
        this.props.deleteCategory({
          _id: key,
          response: {
            success: async () => {
              await this.props.getCategories();
              message.success('Xóa danh mục thành công');
            },
            failure: async (msg = 'Xóa danh mục không thành công') => {
              message.error(msg);
            },
          },
        });
      },
      onCancel: () => {

      },
    });
  }

  render() {
    const { loading, categories } = this.props.category;
    const { searchText } = this.state;

    const tableData = categories.map(category => ({
      key: category._id,
      name: category.name,
      user: category.user,
      roles: rolesToString(category.roles),
      slug: category.slug,
    })).filter(item => (!searchText || prepSearch(item.name).includes(prepSearch(searchText)))
    );

    return (
      <div>
        <p style={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            type="primary"
            onClick={this.createCategory}
            style={{ marginTop: '10px' }}
          >
            <Icon type="file-add" />Tạo danh mục mới
          </Button>
        </p>

        <Input.Search
          value={searchText}
          onChange={e => this.setState({ searchText: e.target.value })}
          placeholder="Tìm bài viết..."
          style={{ marginTop: 5, marginBottom: 20 }}
        />

        {(loading && !tableData.length) ? <Spin /> : <Table columns={this.columns} dataSource={tableData} />}
        
        <p style={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            type="primary"
            onClick={this.createCategory}
            style={{ marginTop: '10px' }}
          >
            <Icon type="file-add" />Tạo danh mục mới
          </Button>
        </p>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  category: state.category,
});

const mapDispatchToProps = {
  getCategories,
  deleteCategory,
};

export default connect(mapStateToProps, mapDispatchToProps)(CategoriesTable);



// WEBPACK FOOTER //
// ./src/screens/Dashboard/Categories/Governance/Categories/CategoriesTable/CategoriesTable.js